import React from "react";
import Layout from "../../layout";
import { Box, Card, CardContent, Grid } from "@mui/material";
import { getUserInfo } from "../../helpers/user";

const Home = () => {
  const user = getUserInfo();
  const hometitle = `Welcome, ${user.first_name}`;

  return (
    <Layout type="home" pageTitle={hometitle} parentUrl="" parentPageName="">
      <Box sx={{ flexGrow: 1, padding: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card variant="outlined" sx={{ borderColor: "transparent" }}>
              <CardContent>
                <Box
                  sx={{
                    mt: 2,
                    textAlign: "end",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 2,
                    }}
                  >
                    <h1>Welcome to the User Dashboard</h1>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};

export default Home;
